import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { Season } from '../../shared/season.model';
import { SeasonDetailComponent } from '../../season-detail/season-detail.component';

@Component({
  selector: 'app-season-modal',
  templateUrl: './season-modal.component.html',
  standalone: true,
  imports: [SharedModule, SeasonDetailComponent],
})
export class SeasonModalComponent {
  constructor(
    private ref: MatDialogRef<SeasonModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  modalTitle = this.data.title;
  season: Season = this.data.obj;
  mode = this.data.params.mode;
  defaultLanguage = this.data.params.defaultLanguage;
  additionalLanguages = this.data.params.additionalLanguages;

  // Referenced from app-season-detail
  onSavedSeason(season) {
    this.ref.close(season); // close the dialog
  }

  // Referenced from app-season-detail
  onCanceledSeason() {
    this.close();
  }

  close() {
    this.ref.close();
  }
}

// @Output() dialogSaved = new EventEmitter<any>(); // avoid closing the dialog
// this.dialogSaved.emit(season); // avoid closing the dialog
